const surveyPoint = (state = { point: null }, action) => {
  if (action.type === "UPDATEPOINT") {
    return (state = {
      point: action.point,
    });
  } else {
    return state;
  }
};
export default surveyPoint;
